module.exports = __webpack_public_path__ + "img/physiology.12a75740.svg";